
import React from "react";
import { Link } from "react-router-dom";
import FooterQuickLinks from "./FooterQuickLinks";
import FooterSocialLinks from "./FooterSocialLinks";
import FooterNewsletter from "./FooterNewsletter";
import FooterRecommendedProducts from "./FooterRecommendedProducts";
import FooterCopyright from "./FooterCopyright";

// Sample recommended products data for the footer
const recommendedProducts = [
  {
    id: 9,
    name: "Hey Humans Natural Deodorant",
    price: 12.99,
    slug: "/shop",
    image: "/lovable-uploads/e3ece06c-b176-4067-a58f-bb4f1c09d65a.png"
  },
  {
    id: 1,
    name: "Grooming Lounge Greatest Pits Deodorant",
    price: 23.00,
    slug: "/shop",
    image: "/lovable-uploads/7553ea87-a17e-481c-b7fb-9548fb2ffd93.png"
  },
  {
    id: 3,
    name: "It Just Works Deodorant",
    price: 35.99,
    slug: "/shop",
    image: "/lovable-uploads/a38e4978-a37a-452c-a67e-140d9acc3d2e.png"
  }
];

const Footer = () => {
  return (
    <footer className="bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <h2 className="text-xl font-semibold">Armpits.com</h2>
            </Link>
            <p className="text-muted-foreground mb-6">
              Your trusted resource for armpit health and wellness information.
            </p>
            <FooterSocialLinks />
          </div>
          
          <FooterQuickLinks />
          
          <FooterRecommendedProducts products={recommendedProducts} />
          
          <FooterNewsletter />
        </div>
        
        <FooterCopyright />
      </div>
    </footer>
  );
};

export default Footer;
